define((require) => {
    "use strict";

    var NavBarView = require("ui/common/NavBarView"),
        template   = require("ui/user/SignInNavBarView.tpl");

    /**
     * The nav bar view for the sign in page: an empty space, void of information.
     *
     * @class SignInNavBarView
     * @constructor
     */
    return NavBarView.extend({

        template: template,

        className: "sign-in-nav-bar"

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/user/SignInNavBarView.js